export default {
      id: "to-usage",
      viewBox: "0 0 9 6",
      url: __webpack_public_path__ + "img/icons.svg#to",
      toString: function () {
        return this.url;
      }
    }